module.exports = __webpack_public_path__ + "static/img/wxpla.17fccdc.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/wxpla.jpg
// module id = xLmN
// module chunks = 1